import type { DatapointOptions, CustomData, InternalDatapointOptions } from "owa-analytics-types";
import { INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT } from "owa-analytics-types";
import type { AnalyticsCoreEventNames } from "owa-analytics-events";
import { lazyLogUsage } from "../lazyFunctions";
import { addStackTraceToEvent } from "owa-analytics-utils/lib/addStackTraceToEvent";
import type { MailboxInfo } from "owa-client-types";

export function logCoreUsage(eventName: AnalyticsCoreEventNames, mailbox: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined, customData?: CustomData, options?: DatapointOptions): Promise<void> {
    const logCoreUsageOptions: InternalDatapointOptions = {
        ...(options ? options : {}),
        ...(mailbox && mailbox !== INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT ? { mailbox } : {}),
    };
    logCoreUsageOptions.isCore = true;
    // Add original stack trace
    addStackTraceToEvent(logCoreUsageOptions);
    
    return lazyLogUsage.importAndExecute(eventName, mailbox, customData, logCoreUsageOptions);
}
